module.exports = __webpack_public_path__ + "static/media/Carlos.7c8c08f6.png";